export default __webpack_public_path__ + "alberta-direct-order-full.62c9b42f60a579256137.svg";